import React from 'react';
import {
  SxProps,
  tableCellClasses,
  TableCell as MuiTableCell,
  TableCellProps as MuiTableCellProps,
} from '@mui/material';

export type TableCellProps = {
  padding?: MuiTableCellProps['padding'] | 'button';
} & Omit<MuiTableCellProps, 'padding'>;

const getPaddingStyles = (padding: MuiTableCellProps['padding'] | 'button'): SxProps | void => {
  if (padding === 'button') {
    return {
      py: 0.375,

      [`&.${tableCellClasses.root}`]: {
        pr: 2,
      },
    };
  }
  return;
};

export const TableCell: React.FC<TableCellProps> = ({ padding, classes, sx, ...rest }) => {
  return (
    <MuiTableCell
      classes={classes}
      padding={padding === 'button' ? undefined : padding}
      sx={(theme) => ({
        ...getPaddingStyles(padding),
        ...(typeof sx === 'function' ? sx(theme) : sx),
      })}
      {...rest}
    />
  );
};
